import CoupounCard from '@elem/SVGIcon/DeltaProUltra/CoupounCard';
import CouponPast from '@elem/SVGIcon/DeltaProUltra/CouponPast';
import CouponPastPC from '@elem/SVGIcon/DeltaProUltra/CouponPastPC';
import CouponPastPad from '@elem/SVGIcon/DeltaProUltra/CouponPastPad';
import CouponPastH5 from '@elem/SVGIcon/DeltaProUltra/CouponPastH5';
import CoupounCardDesktop from '@elem/SVGIcon/DeltaProUltra/CoupounCardDesktop';
import CoupounCardPad from '@elem/SVGIcon/DeltaProUltra/CoupounCardPad';
import CoupounCardH5 from '@elem/SVGIcon/DeltaProUltra/CoupounCardH5';
import CoupounCardFloat from '@elem/SVGIcon/DeltaProUltra/CoupounCardFloat';
import CoupounCardFloatDesktop from '@elem/SVGIcon/DeltaProUltra/CoupounCardFloatDesktop';
import CoupounCardFloatPad from '@elem/SVGIcon/DeltaProUltra/CoupounCardFloatPad';
import CoupounCardFloatH5 from '@elem/SVGIcon/DeltaProUltra/CoupounCardFloatH5';
import { getCoupounInventory } from '@elem/Service/delta-pro-ultra';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getSolarRecommand } from '@/service/solar-calculator';

export default function C({ callback }: any) {
    const { useLang, useRouter, useEffect, useState, Link, gtm } = useGlobal();
    const { t } = useLang('delta_pro_ultra.prelaunch');
    const { locale } = useRouter();
    // 库存
    const [inventory, setInventory] = useState(0);
    // 最大库存/库存总数
    const [maxInventory, setMaxInventory] = useState(locale === 'us' ? 1000 : 500);
    // 是否变色
    const [showStock, setShowStock] = useState(false);
    // 变色阀值 threshold
    const INVENTORY_THRESHOLD = 100;

    useEffect(() => {
        (async () => {
            if (locale !== 'us') {
                try {
                    const res = await getCoupounInventory(locale);
                    if (res?.code === '0') {
                        setInventory(res?.data?.inventory);
                        setMaxInventory(res?.data?.maxInventory);
                        setShowStock(res?.data?.showStock);
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        })();
    }, []);

    const shopifyLocal: any = {
        us: {
            productId: '6923283693641',
            variantId: '40646098681929',
        },
        ca: {
            productId: '7960581996698',
            variantId: '44035721363610',
        },
    };

    const timelines: any[] = [
        {
            title: t('secC_timeline1_title'),
            desc: t('secC_timeline1_desc'),
        },
        {
            title: t('secC_timeline2_title'),
            desc: t('secC_timeline2_desc'),
        },
        {
            title: t('secC_timeline3_title'),
            desc: t('secC_timeline3_desc'),
        },
    ];

    useEffect(() => {
        const getAsynItem = async (productId: string, variantId: string) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (locale === 'us') {
                            setInventory(res?.data?.inventoryQuantity ?? 0);
                        }
                        callback(`https://${locale}.ecoflow.com/cart/${shopifyLocal[locale]?.variantId}:1?channel=buy_button`);
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        getAsynItem(shopifyLocal[locale]?.productId, shopifyLocal[locale]?.variantId);
    }, []);

    return (
        <div id="delta-pro-ultra-prelaunch-C" className={`delta-pro-ultra-C ${css['delta-pro-ultra-C']}`}>
            <div className="text-box">
                <p className="title">
                    {t.rich('secC_title', {
                        m: (text: string) => <span className="multi">{text}</span>,
                    })}
                </p>
                <p className="desc desc-pc">
                    {t.rich('secC_desc', {
                        n: (text: string) => <span className="no-wrap">{text}</span>,
                        s: (text: string) => <span className="high">{text}</span>,
                    })}
                </p>
                <p className="desc desc-pad">
                    {t.rich('secC_desc_pad', {
                        n: (text: string) => <span className="no-wrap">{text}</span>,
                        s: (text: string) => <span className="high">{text}</span>,
                    })}
                </p>
                <p className="desc desc-h5">
                    {t.rich('secC_desc_h5', {
                        n: (text: string) => <span className="no-wrap">{text}</span>,
                        s: (text: string) => <span className="high">{text}</span>,
                    })}
                </p>
            </div>
            <div className="card">
                <CoupounCard className="svg-card pc" locale={locale} />
                <CoupounCardDesktop className="svg-card desktop" locale={locale} />
                <CoupounCardPad className="svg-card pad" locale={locale} />
                <CoupounCardH5 className="svg-card h5" locale={locale} />

                <CoupounCardFloat className="svg-card-float pc" />
                <CoupounCardFloatDesktop className="svg-card-float desktop" />
                <CoupounCardFloatPad className="svg-card-float pad" />
                <CoupounCardFloatH5 className="svg-card-float h5" />

                {/* {locale === 'us' && <span className="tag">{t('secC_card_tag')}</span>} */}
                {locale === 'us' && <div className="tag-img">{t('secC_card_tag_text')}</div>}
                <div className="card-info">
                    <h3 className="card-title">{t('secC_card_title')}</h3>
                    <p className="card-desc">
                        {t.rich('secC_card_desc', {
                            sub: (text: any) => <sup>{text}</sup>,
                            green: (text: any) => <span className="green">{text}</span>,
                            b: (text: any) => <span className="b">{text}</span>,
                            n: (text: any) => <span className="no-wrap">{text}</span>,
                            s: (text: any) => <span className="space">{text}</span>,
                        })}
                    </p>
                    <svg className="dash-line" width="793" height="2" viewBox="0 0 793 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line y1="1.0743" x2="792.402" y2="1.0743" stroke="#3F3F3F" strokeWidth="1.85141" strokeDasharray="9.26 9.26" />
                    </svg>
                    <div className={`control ${inventory >= INVENTORY_THRESHOLD && locale !== 'us' ? 'full' : 'nearby'}`}>
                        <div className="progress-box">
                            <div className="progress-bar">
                                <span className="progress-bar-color" style={{ width: `${((maxInventory - inventory) * 100) / maxInventory}%` }}></span>
                            </div>
                            <span className="progress-text">
                                {!showStock ? t('secC_card_sold') + (maxInventory - inventory) : t('secC_card_stock') + inventory}
                            </span>
                        </div>
                        <button
                            className={`buy-now ${inventory <= 0 ? 'disable' : ''}`}
                            disabled={inventory <= 0}
                            onClick={() => {
                                if (inventory > 0) {
                                    try {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'buy',
                                            product_name: 'DELTA Pro Ultra coupons',
                                            position: 'Early Bird',
                                        });
                                        // gtm.push({
                                        //     event: 'uaEvent',
                                        //     event_name: 'buy',
                                        //     product_name: 'DELTA Pro Ultra coupons',
                                        //     position: 'Product PreLaunch',
                                        // });
                                        window?.fbq && window?.fbq('track', 'Lead');
                                    } catch (e) {
                                        console.error(e);
                                    } finally {
                                        window.open(
                                            `https://${locale}.ecoflow.com/cart/${locale === 'ca' ? '44035721363610' : '40646098681929'}:1?channel=buy_button`,
                                            '_blank',
                                        );
                                    }
                                }
                            }}
                        >
                            {t('secC_card_buy')}
                        </button>
                    </div>
                    <p className="card-quantity">
                        <span className="quantity">{t('secC_card_quantity')}</span>
                        {locale === 'us' && <span className="quantity-tip">{t('secC_card_quantity_tip')}</span>}
                    </p>
                </div>
            </div>
            {locale == 'us' && (
                <div className="past-coupon">
                    <CouponPast className="desktop" />
                    <CouponPastPC className="pc" />
                    <CouponPastPad className="pad" />
                    <CouponPastH5 className="h5" />
                    <div className="past-info">
                        {/* <span className="past-circle">{t('secC_coupon_past_circle')}</span> */}
                        <div className="past-tag">{t('secC_coupon_past_circle')}</div>
                        <p className="past-title">{t('secC_coupon_past_title')}</p>
                        <svg className="dash-line" width="793" height="2" viewBox="0 0 793 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line y1="1.0743" x2="792.402" y2="1.0743" stroke="#3F3F3F" strokeWidth="1.85141" strokeDasharray="9.26 9.26" />
                        </svg>
                        <p className="past-desc">{t('secC_coupon_past_desc')}</p>
                    </div>
                </div>
            )}
            <ul className="time-lines">
                {timelines?.map((tl: any, k: number) => (
                    <li className="time-line" key={k}>
                        <p className="tl-title">{tl?.title}</p>
                        <p className="tl-desc">{tl?.desc}</p>
                    </li>
                ))}
            </ul>
            <p className="memo">
                {t.rich('secC_memo', {
                    sub: (text: any) => <sup>{text}</sup>,
                    n: (text: string) => <span className="no-wrap">{text}</span>,
                    store: (text: string) => (
                        <Link className="link" href={`https://${locale}.ecoflow.com/`}>
                            {text}
                        </Link>
                    ),
                })}
            </p>
        </div>
    );
}
